import React, { useState, useEffect } from "react";
import MultiLanguageTranslation from "../../../../../_components/Translate/MultiLangTranslate";
import "../../commonStyle.css";
import { isMobile } from "../../helperFunc";
import { location, locationBlue, PencilBlue } from "../../icon_assets";
import HeadLinesSpan from "../HeadlinesSpan";
import LocationFilter from "../LocationFilter/LocationFilter";

const Location = (props) => {
  const {
    blueLocationIcon = false,
    editIcon = false,
    city = [],
    FilterData = [],
    showLocationFilter = true,
    isOpenCityFilter = false,
    setIsOpenCityFilter = () => null,
    prevCommodity = "",
    commodity,
    setCommodity = () => null,
    prevCityId,
    selectedCityId = 0,
    setCityId = () => null,
    setLocation = () => null,
    selectedLocation = "",
    mandiBhavPage = false,
  } = props;
  // const [cityId, setCityId] = useState(selectedCityId);
  const [locationLang, setLocationLang] = useState("");
  useEffect(() => {
    if (selectedCityId !== 0) {
      FilterData(selectedCityId);
    }
  }, [selectedCityId]);

  useEffect(() => {
    if (isOpenCityFilter === false) {
      if (selectedCityId === 0 && selectedLocation.trim() === "") {
        // showAll();
        setCommodity("");
      } else if (
        // prevCommodity !== "" &&
        prevCommodity?.commodity_id !== commodity?.commodity_id &&
        prevCityId === selectedCityId
      ) {
        setCommodity(prevCommodity);
        // FilterData(selectedCityId, prevCommodity);
      }
    }
  }, [isOpenCityFilter]);

  useEffect(() => {
    setIsOpenCityFilter(false);
  }, [selectedLocation]);

  return (
    <>
      <span
        className={`${
          !isMobile ? `font-size20` : `font-size12`
        } d-flex align-items-center ${
          showLocationFilter ? "textColorBlue" : "colorDark9"
        }`}
        style={{ pointerEvents: showLocationFilter ? "auto" : "none" }}
      >
        <img
          src={blueLocationIcon ? locationBlue : location}
          alt=""
          style={{ marginRight: "4.8px" }}
          width={!isMobile && 11}
          height={!isMobile && 16}
        />{" "}
        {selectedLocation === "" || !showLocationFilter ? (
          <MultiLanguageTranslation title={`India`} />
        ) : locationLang === "" ? (
          <HeadLinesSpan
            text={selectedLocation}
            className={"cursorPointer"}
            onClick={() => {
              setIsOpenCityFilter(true);
            }}
          />
        ) : (
          <HeadLinesSpan
            text={locationLang}
            className={"cursorPointer"}
            onClick={() => {
              setIsOpenCityFilter(true);
            }}
          />
        )}
        {editIcon && (
          <img
            src={PencilBlue}
            style={{ marginLeft: "5px" }}
            alt=""
            onClick={() => {
              setIsOpenCityFilter(true);
            }}
          />
        )}
      </span>
      <LocationFilter
        show={isOpenCityFilter}
        setShow={setIsOpenCityFilter}
        location={selectedLocation}
        setLocation={setLocation}
        setLocationLang={setLocationLang}
        cityList={city}
        setCityId={setCityId}
        mandiBhavPage={mandiBhavPage}
      />
    </>
  );
};

export default Location;
